import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  Avatar,
  Container,
  Skeleton,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useDispatch, useSelector } from "react-redux";
import { StoreDispatch, StoreState } from "../redux/reduxStore.ts";
import { getAllProductCategory } from "../services/product/services.ts";
import {
  CategoryApiResponse,
  CategoryItem,
} from "../services/product/types.ts";
import { useNavigate } from "react-router-dom";
import images from "../constant/images.ts";

// ✅ Add this at the top — your image mapping
const categoryImages = [
  { name: "gin", link: "https://viinarannasta.eu/304-superlarge_default/Beefeater_Gin_40__100cl.jpg" },
  { name: "rum", link: "https://divino.mt/cdn/shop/products/bumbu-original-rum-70cl_1200x1200.png?v=1634591554" },
  { name: "vodka", link: "https://www.cheerswinemerchants.co.uk/cdn/shop/products/smirnoff-red-label-vodka-70cl_50ecc35b-5b0b-4252-81ee-92fafcbc1e11.jpg?v=1591918065&width=1024" },
  { name: "whiskey", link: "https://images-cdn.ubuy.co.in/64ce5c03e612004d4d206c6c-jack-daniel-s-old-no-7-tennessee.jpg" },
  { name: "tequila", link: "https://cdn.selection-prestige.de/media/catalog/product/cache/image/1536x/a4e40ebdc3e371adff845072e1c73f37/1/0/103015_jose-cuervo-especial-tequila-reposado-07l-38-vol.jpg" },
  { name: "sangrita", link: "https://www.tasteboutique.com/cdn/shop/products/SANGRITA_VIUDA_DE_SANCHEZ_LITRO_348x.png?v=1631909954" },
  { name: "cognac", link: "https://cognac-select.com/cdn/shop/files/NewProject_1_9c03cc56-7031-42ac-829b-71ff12037790.png?v=1684396784" },
  { name: "liqueurs", link: "https://www.willowpark.net/cdn/shop/products/5959_Baileys_9c39a5b9-4c2b-4c8b-8ccc-cb1fe438a07e.png?v=1599760640" },
  { name: "vermouth", link: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTPURfcVyLXDB_8zYaOF4U8Q9CEtx7DUojvGg&s" },
  { name: "ice", link: "https://moosehead-bier.de/cdn/shop/products/MooseheadDryIceDoseeinzel_800x.png?v=1657023570" },
  { name: "brandy", link: "https://www.colonialspirits.com/wp-content/uploads/2016/01/christian-brothers.png" },
  { name: "cleaning", link: "https://www.cooksmill.co.uk/Content/131/NewsPageBuilderImage/cleaning%20products%20blog.jpg" },
  { name: "balloons", link: "https://www.equippers.com/media/catalog/category/L2_cleaning-supplies_1.jpg" },
  { name: "champagne", link: "https://cdn.thewirecutter.com/wp-content/media/2024/02/hard-seltzer-2048px-5997.jpg?auto=webp&quality=75&width=1024" },
  { name: "juice", link: "https://shop.morand.ch/img/cms/sirups.jpg" },
];

const getImageForCategory = (name: string) => {
  const found = categoryImages.find((item) => item.name === name.toLowerCase());
  return found ? found.link : "";
};

const AllCategories = () => {
  const [categories, setCategories] = useState<CategoryItem[]>([]);
  const userData = useSelector((state: StoreState) => state.user);
  const dispatch = useDispatch<StoreDispatch>();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    getAllProductCategory({})
      .then((data: any) => {
        if (data) setCategories(data?.data as CategoryApiResponse["data"]);
      })
      .catch((e) => console.log(e))
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      {/* <Box
        sx={{
          backgroundColor: "white",
          width: "100%",
          height: 90,
          boxShadow: 3,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
        }}
      >
        <IconButton
          sx={{ position: "absolute", top: 30, left: 20 }}
          onClick={() => navigate("/")}
        >
          <ArrowBackIcon sx={{ color: "black", fontSize: 25 }} />
        </IconButton>
        <Avatar
          src={images.logo}
          alt="Logo"
          sx={{ width: 56, height: 56 }}
        />
      </Box> */}

      <Container sx={{ py: 4 }}>
        <Typography variant="h4" sx={{ color: "primary.main", mb: 3 }}>
          Categories
        </Typography>

        {categories?.length > 0 && !loading ? (
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr 1fr",
                sm: "1fr 1fr 1fr",
                md: "1fr 1fr 1fr 1fr",
              },
              gap: 4,
              px: 2,
            }}
          >
            {categories.map((item, index) => (
              <Box
                key={index}
                onClick={() =>
                  navigate(`/category-product/${item.pCategoryId}/${item.name}`)
                }
                sx={{
                  textAlign: "center",
                  cursor: "pointer",
                  transition: "transform 0.2s ease",
                  "&:hover": {
                    transform: "scale(1.05)",
                  },
                }}
              >
                <Box
                  component="img"
                  src={getImageForCategory(item.name)}
                  alt={item.name}
                  sx={{
                    width: 140,
                    height: 130,
                    objectFit: "cover",
                    borderRadius: "50%",
                    mx: "auto",
                    mb: 1.5,
                    boxShadow: 3,
                  }}
                />
                <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                  {item.name}
                </Typography>
                <Typography
              variant="body2"
              sx={{
                color: "text.secondary",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                WebkitLineClamp: 3,
                WebkitBoxOrient: "vertical",
              }}
            >
              {item.description}
            </Typography>
              </Box>
            ))}
          </Box>
        ) : (
          <Skeleton
            variant="rectangular"
            width="100%"
            height={60}
            sx={{ borderRadius: 1, backgroundColor: "grey.300" }}
          />
        )}
      </Container>
    </>
  );
};

export default AllCategories;
